import React from 'react';
import {observer} from 'mobx-react';
import {SOCCER_EVENT_TYPES} from "../../../../../../core/app/consts";
import styles from "../../styles/match-event.module.scss";
import classNames from "classnames";

export const MatchEventsModuleEventContent = observer(({event, controller, swapDirection}) => {
  const {device: {isSmallView}, state: {terms}} = controller;
  const {player, subsPlayerShortName, subTitle, eventType} = event;
  const {WEB_GAME_CENTER_AND_NOTIFICATION_MISSES_NEXT_MATCH} = terms
  const {name, shortName} = player

  const playerName: String = isSmallView ? shortName || name : name;
  const subsPlayerName: String = isSmallView ? subsPlayerShortName : subTitle;

  const isSwitchEvent: Boolean = eventType.id === SOCCER_EVENT_TYPES.substitution;
  const isYellowCardEvent: Boolean = eventType.id === SOCCER_EVENT_TYPES.yellowCard;
  const showSuspensionRisk: Boolean = isYellowCardEvent && player.suspensionRisk;
  const homeSubstitution: Boolean = swapDirection && isSwitchEvent;
  const awaySubstitution: Boolean = !swapDirection && isSwitchEvent;

  const swapDirectionClassName: String = swapDirection ? styles.away_event : styles.home_event;
  const titleClassName: String = isSwitchEvent ? styles.switch_event_title : styles.event_title;
  const subtitleClassName: String = isSwitchEvent ? styles.switch_event_subtitle : styles.event_subtitle;
  const containerClassName = classNames(styles.event, swapDirectionClassName,
    {[styles.away_substitution_event]: homeSubstitution},
    {[styles.home_substitution_event]: awaySubstitution});

  return (
    <div className={classNames(containerClassName)}>
      <div className={classNames(titleClassName)}>{playerName}</div>
      {
        subsPlayerName ? <div className={classNames(subtitleClassName)}>
          {isSwitchEvent ? subsPlayerName : `${subsPlayerName}`}
        </div> : null
      }
      {
        showSuspensionRisk ? <div className={classNames(subtitleClassName)}>
          {WEB_GAME_CENTER_AND_NOTIFICATION_MISSES_NEXT_MATCH}
        </div> : null
      }
    </div>
  )
});